"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigate = void 0;
var useNavigate_1 = require("./useNavigate");
Object.defineProperty(exports, "useNavigate", { enumerable: true, get: function () { return useNavigate_1.useNavigate; } });
